$(() => {
  //onload add active class to first card element
  $(window).on("load", () => {
    $(".bs-section--association-careers-current-job .card")
      .first()
      .addClass("active");
  });
  $(".bs-section--association-careers-current-job .card-header").on(
    "click",
    (e) => {
      $(e.currentTarget).parent().toggleClass("active");
      $(".bs-section--association-careers-current-job .active")
        .not($(e.currentTarget).parent())
        .removeClass("active");
      const windowWidth = $(window).width();
      $(".bs-section--association-careers-current-job .card .collapse")
        .not($(e.currentTarget).next())
        .slideUp();
      $(e.currentTarget).next().slideToggle();
    }
  );
});
